import styled from 'styled-components'

import { Text } from '@reveni-io/reveni-ui'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp8};
  padding: ${props => props.theme.spacing.sp12};
  background-color: ${props => props.theme.colors.background.secondary};
  border-radius: ${props => props.theme.spacing.sp8};
`

export const TopRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: ${props => props.theme.spacing.sp8};
  width: 100%;
`

export const BottomRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${props => props.theme.spacing.sp8};
`

export const ExternalLink = styled.a`
  color: ${props => props.theme.link.color};
  text-decoration: underline;
`

export const NoteText = styled(Text)`
  flex: 1;
  font-style: italic;
`
